module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-5-91fa7eb0.png";